/* Carmen Hrawi – motion layer v2 (no dependencies) */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  var root = document.documentElement;

  /* ---------- Tilt helper ---------- */
  function attachTilt(el, maxDeg, glare) {
    if (!canHover || reduce || el.__chTilt) return;
    el.__chTilt = true;
    var raf = null;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        el.classList.add('is-tilting');
        el.style.setProperty('--ch-ry', ((px - 0.5) * maxDeg * 2).toFixed(2) + 'deg');
        el.style.setProperty('--ch-rx', ((0.5 - py) * maxDeg * 2).toFixed(2) + 'deg');
        if (glare) {
          el.style.setProperty('--ch-gx', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--ch-gy', (py * 100).toFixed(1) + '%');
        }
      });
    });
    el.addEventListener('pointerleave', function () {
      if (raf) cancelAnimationFrame(raf);
      el.classList.remove('is-tilting');
      el.style.setProperty('--ch-rx', '0deg');
      el.style.setProperty('--ch-ry', '0deg');
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var io = null;
  if ('IntersectionObserver' in window && !reduce && !designMode) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting || en.intersectionRatio > 0) show(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }

  // Things already on screen at load stay put (no flash); only content below the fold animates in
  var booted = false;
  function aboveFold(el) {
    if (booted) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (!vh) return true; // can't measure: never hide
    return el.getBoundingClientRect().top < vh * 0.92;
  }

  // Safety net: whatever happens with IntersectionObserver, nothing stays hidden
  var pending = [];
  function show(el) { el.classList.add('is-in'); if (io) io.unobserve(el); }
  function sweep(all) {
    var vh = window.innerHeight || document.documentElement.clientHeight || 99999;
    pending = pending.filter(function (el) {
      if (el.classList.contains('is-in')) return false;
      if (all || el.getBoundingClientRect().top < vh) { show(el); return false; }
      return true;
    });
  }
  var sweepTimer = null;
  window.addEventListener('scroll', function () {
    if (sweepTimer) return;
    sweepTimer = setTimeout(function () { sweepTimer = null; sweep(false); }, 150);
  }, { passive: true });
  window.addEventListener('load', function () { setTimeout(function () { sweep(false); }, 800); });
  setTimeout(function () { sweep(false); }, 3000);
  // Tabs opened in the background don't render, so re-check when the tab is shown
  document.addEventListener('visibilitychange', function () { if (!document.hidden) setTimeout(function () { sweep(false); }, 300); });

  function track(el) { pending.push(el); io.observe(el); }

  function reveal(el, delay) {
    if (!io || el.__chReveal) return;
    el.__chReveal = true;
    if (aboveFold(el)) return;
    el.classList.add('ch-reveal');
    if (delay) el.style.setProperty('--ch-delay', delay + 's');
    track(el);
  }

  // Headings rise out of a mask (same move as the hero title). The heading keeps all its own
  // content and attributes; only two plain wrappers are added around what's inside it.
  function rise(h) {
    if (!io || h.__chRise) return;
    h.__chRise = true;
    // headings inside a block that already reveals as a whole keep that single motion
    if (aboveFold(h) || h.querySelector('.ch-mask') || h.closest('[data-ch-reveal], .ch-reveal')) return;
    var mask = document.createElement('span');
    mask.className = 'ch-mask';
    var inner = document.createElement('span');
    inner.className = 'ch-mask__in';
    while (h.firstChild) inner.appendChild(h.firstChild);
    mask.appendChild(inner);
    h.appendChild(mask);
    h.classList.add('ch-rise');
    track(h);
  }

  function enhance(scope) {
    scope = scope || document;

    // Product + collection cards: 3D tilt + staggered reveal
    var grids = scope.querySelectorAll('.grid, .slider, .collage');
    grids.forEach(function (grid) {
      var cards = grid.querySelectorAll(':scope > li .card-wrapper, :scope > .grid__item .card-wrapper, :scope > .collage__item > .card-wrapper');
      cards.forEach(function (card, i) {
        var inner = card.querySelector('.card') || card;
        inner.classList.add('ch-tilt');
        if (canHover && !reduce && !inner.querySelector(':scope > .ch-glare')) {
          var g = document.createElement('span');
          g.className = 'ch-glare';
          g.setAttribute('aria-hidden', 'true');
          inner.appendChild(g);
        }
        attachTilt(inner, 7, true);
        reveal(card.closest('li') || card, Math.min(i % 4, 3) * 0.09);
      });
    });

    // Text blocks and media
    scope.querySelectorAll(
      '.image-with-text__media, .image-with-text__content, .rich-text__blocks > :not(.rich-text__heading), .multicolumn-card, .collapsible-content__grid > *, .newsletter__wrapper'
    ).forEach(function (el, i) { reveal(el, (i % 3) * 0.08); });

    // Custom sections opt in with data attributes
    scope.querySelectorAll('[data-ch-reveal]').forEach(function (el, i) { reveal(el, (i % 3) * 0.08); });
    scope.querySelectorAll('[data-ch-curtain]').forEach(function (el) {
      if (!io || el.__chCurtain) return;
      el.__chCurtain = true;
      if (aboveFold(el)) return;
      el.classList.add('ch-curtain');
      track(el);
    });

    // Section headings
    scope.querySelectorAll(
      '.title-wrapper h2, .title-wrapper-with-link h2, .rich-text__heading, .image-with-text__heading, .banner__heading, .ch-h2, [data-ch-rise]'
    ).forEach(rise);

    // Product page: gentle 3D tilt on the main image
    scope.querySelectorAll('.product__media-item.is-active .product-media-container, .product__media-list > li:first-child .product-media-container')
      .forEach(function (m) {
        m.classList.add('ch-media-3d');
        attachTilt(m, 4, false);
      });
  }

  /* ---------- Shared-element page transition: card image -> product image ---------- */
  // Only names the image for the browser's native transition; never blocks or delays the click.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var card = link.closest('.card-wrapper');
    var img = card && card.querySelector('.card__media img');
    if (img) {
      document.querySelectorAll('[style*="ch-product-hero"]').forEach(function (n) { n.style.viewTransitionName = ''; });
      img.style.viewTransitionName = 'ch-product-hero';
    }
  }, true);

  // On the product page, give the first image the matching name
  window.addEventListener('pagereveal', function () {
    if (!/\/products\//.test(location.pathname)) return;
    var hero = document.querySelector('.product__media-list > li:first-child img, .product__media-item img');
    if (hero) {
      hero.style.viewTransitionName = 'ch-product-hero';
      setTimeout(function () { hero.style.viewTransitionName = ''; }, 900);
    }
  });

  // Coming back to a page from the browser cache: clear any leftover names so the next
  // transition starts clean
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[style*="ch-product-hero"]').forEach(function (n) { n.style.viewTransitionName = ''; });
  });

  /* ---------- Header shadow on scroll ---------- */
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('ch-scrolled', window.scrollY > 40);
      ticking = false;
    });
  }, { passive: true });

  /* ---------- Add to cart: confirm with "Added" + tick ---------- */
  var lastSubmit = null;
  document.addEventListener('submit', function (e) {
    var btn = e.target.querySelector && e.target.querySelector('.product-form__submit');
    if (btn) lastSubmit = btn;
  }, true);

  var TICK = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3L13 4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function confirmAdded(btn) {
    var label = btn && btn.querySelector(':scope > span:not(.sold-out-message)');
    if (!label || btn.__chAdded) return;
    btn.__chAdded = true;
    var original = label.innerHTML;
    label.innerHTML = '<span class="ch-added-label">' + TICK + '<span>Added</span></span>';
    if (!reduce) {
      btn.classList.remove('ch-added');
      void btn.offsetWidth;
      btn.classList.add('ch-added');
    }
    setTimeout(function () {
      // Only restore if nothing else (like a variant change) has rewritten the label meanwhile
      if (label.querySelector('.ch-added-label')) label.innerHTML = original;
      btn.classList.remove('ch-added');
      btn.__chAdded = false;
    }, 2000);
  }

  function listenForCart() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form' || !lastSubmit) return;
      if (event.cartData && event.cartData.status) return; // error response
      confirmAdded(lastSubmit);
    });
    return true;
  }

  /* ---------- Cart count bumps when it changes ---------- */
  function watchCartIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon || icon.__chWatch || !('MutationObserver' in window)) return;
    icon.__chWatch = true;
    new MutationObserver(function () {
      if (reduce) return;
      var bubble = icon.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('ch-bump');
      void bubble.offsetWidth;
      bubble.classList.add('ch-bump');
    }).observe(icon, { childList: true, subtree: true });
  }

  /* ---------- Cart drawer: items settle in when it opens ---------- */
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__chWatch || !('MutationObserver' in window)) return;
    drawer.__chWatch = true;
    var wasOpen = drawer.classList.contains('active');
    var timer = null;
    new MutationObserver(function () {
      var open = drawer.classList.contains('active');
      if (open && !wasOpen && !reduce) {
        drawer.querySelectorAll('.cart-item').forEach(function (row, i) { row.style.setProperty('--ch-i', Math.min(i, 6)); });
        drawer.classList.add('ch-drawer-intro');
        clearTimeout(timer);
        timer = setTimeout(function () { drawer.classList.remove('ch-drawer-intro'); }, 1300);
      }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Boot ---------- */
  function boot() {
    enhance(document);
    booted = true;
    watchCartIcon();
    watchDrawer();
    // Dawn's cart scripts load with defer too; try now and once more after load
    if (!listenForCart()) window.addEventListener('load', listenForCart, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-run when Shopify swaps sections (filters, variant changes, theme editor)
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target); watchCartIcon(); watchDrawer(); });
  if ('MutationObserver' in window) {
    var moTimer = null;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) {
          clearTimeout(moTimer);
          moTimer = setTimeout(function () { enhance(document); }, 120);
          break;
        }
      }
    });
    var main = document.getElementById('MainContent');
    if (main) mo.observe(main, { childList: true, subtree: true });
  }
})();